import React from "react";
import { Loader2 } from "lucide-react";
import { EligibleBadge } from "@/components/email/EmParts";

const EX = { no_consent: "No consent", suppressed: "Suppressed", unsubscribed: "Unsubscribed", invalid_email: "Invalid email", no_email: "No email", duplicate_email: "Duplicate email (sent once)" };

export default function AudiencePreview({ p, testId = "audience-preview" }) {
  if (!p) return <Loader2 className="w-4 h-4 animate-spin text-slate-400" />;
  return (
    <div className="space-y-3" data-testid={testId}>
      <div className="grid grid-cols-3 gap-2 text-center">
        {[["Matching", p.matched, "text-slate-900", "matched"], ["Eligible", p.eligible, "text-emerald-700", "eligible"], ["Will receive", p.recipients, "text-indigo-700", "recipients"]].map(([l, v, c, k]) => (
          <div key={l} className="bg-slate-50 rounded-lg p-2"><p className="text-[11px] uppercase text-slate-400">{l}</p><p className={`text-xl font-bold tabular-nums ${c}`} data-testid={`${testId}-${k}`}>{(v || 0).toLocaleString()}</p></div>))}
      </div>
      <div className="text-xs text-slate-600 space-y-0.5" data-testid={`${testId}-excluded`}>
        <p className="font-semibold text-slate-700">Excluded</p>
        {Object.entries(p.excluded || {}).filter(([, n]) => n > 0).map(([k, n]) => <p key={k} className="flex justify-between"><span>{EX[k] || k}</span><span className="tabular-nums">{n.toLocaleString()}</span></p>)}
        {!Object.values(p.excluded || {}).some((n) => n > 0) && <p className="text-slate-400">Nobody excluded</p>}
      </div>
      {(p.eligible_sample?.length > 0 || p.excluded_sample?.length > 0) && (
        <div className="text-xs space-y-1">
          {[...(p.eligible_sample || []), ...(p.excluded_sample || [])].slice(0, 10).map((s) => (
            <p key={s.id} className="flex justify-between gap-2"><span className="truncate">{`${s.first_name} ${s.last_name}`.trim() || "—"} · {s.email || "no email"}</span><EligibleBadge sub={s} /></p>))}
        </div>)}
    </div>
  );
}
